import { createInMemoryAtom } from '@exodus/atoms'

const createApyRatesAtom = () => createInMemoryAtom({ defaultValue: {} })

export default createApyRatesAtom
